var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10711",
    "data-name": "Group 10711",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.557,
    height: 54.557,
    viewBox: "0 0 54.557 54.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6897",
    "data-name": "Path 6897",
    d: "M1409.125,235.225a27.279,27.279,0,1,0-31.541,26.947V243.11h-6.926v-7.885h6.926v-6.01c0-6.837,4.073-10.613,10.3-10.613a41.952,41.952,0,0,1,6.106.533v6.713h-3.439c-3.389,0-4.446,2.1-4.446,4.26v5.117h7.565l-1.209,7.885h-6.356v19.062A27.286,27.286,0,0,0,1409.125,235.225Z",
    transform: "translate(-1354.567 -207.946)",
    fill: "#394f65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6898",
    "data-name": "Path 6898",
    d: "M1416.188,258.821l1.209-7.885h-7.565v-5.117c0-2.157,1.057-4.26,4.446-4.26h3.439v-6.713a41.956,41.956,0,0,0-6.106-.533c-6.231,0-10.3,3.777-10.3,10.613v6.01h-6.926v7.885h6.926v19.062a27.577,27.577,0,0,0,8.525,0V258.821Z",
    transform: "translate(-1378.291 -223.657)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.21a66c64f57629b29a4b6e98eda71d3e.svg";
export { ForwardRef as ReactComponent };